<div class="one-morning" *ngIf="employer">
	<section class="hero" [class.custom-hero]="hasCustomHero" [style.background-image]="heroBackgroundImage" [style.background-position]="heroFocalPosition || null">
		<h2 [innerHTML]="heroHeadingText"></h2>
	</section>

	<section class="well-being">
		<div class="copy fade-in">
			<div class="pre-headline" [translate]="'learnmore-wellbeing-preheadline'">Support for Lifes Challenges</div>
			<div class="headline" [translate]="'learnmore-wellbeing-headline'">Mental health doesn't discriminate between life and work.</div>
			<div class="text" [translate]="'learnmore-wellbeing-text'">Everybody is dealing with something&mdash;life on life's terms can be lonely, drive fear, and can paralyze us. Calls for help hide behind a smile. Mental health conditions and substance use disorders are biological brain disorders, not issues of willpower, character or intelligence. Hope is what we do.</div>
		</div>
	</section>

	<!-- R11 (Revisions02 #3): both videos in one carousel — Moments of Realization first,
	     dot toggle like the home-page video cards. A slide change pauses whatever is playing. -->
	<section class="video-carousel">
		<p-carousel [value]="videos" [numVisible]="1" [numScroll]="1" [circular]="false" [showIndicators]="true" [showNavigators]="false" (onPage)="pauseVideos()">
			<ng-template let-vid pTemplate="item">
				<video #lmVideo [attr.poster]="vid.poster" controls crossorigin="anonymous" [interact]="{ engagementTypeID: 1, resource: vid.resource }">
					<source [src]="vid.src" type="video/mp4" />
					<track *ngFor="let lang of subtitleLangs" [src]="vid.vttBase + '-' + lang.code + '.vtt'" kind="subtitles" [srclang]="lang.code" [label]="lang.label" [attr.default]="lang.code !== 'en' && currentLanguage === lang.code ? '' : null" />
				</video>
			</ng-template>
		</p-carousel>
	</section>

	<div class="sunrise">
		<section class="topics fade-in" *ngIf="topicCardsToShow">
			<div class="pre-headline" [translate]="'learnmore-topics-preheadline'">You don't have to struggle alone.</div>
			<div class="headline" [translate]="'learnmore-topics-headline'">Just because you can handle it,<br />doesn't mean you should.</div>
			<ng-container *ngIf="eapData as data">
				<a *ngIf="data['CTA Button 1 Type'] === 'Visit EAP'" class="cta" [href]="data['CTA Button 1 URL']" target="_blank" [interact]="{ engagementTypeID: 4, resource: 'CTA Button 1 - Learn More' }" [innerHTML]="cta1Text"></a>
				<a *ngIf="data['CTA Button 1 Type'] === 'Call EAP'" class="cta" [href]="'tel:' + sanitizePhone(data['CTA Button 1 Phone'])" [interact]="{ engagementTypeID: 4, resource: 'CTA Button 1 - Learn More' }" [innerHTML]="cta1Text"></a>
				<span *ngIf="data['CTA Button 1 Type'] === 'Call EAP'" class="call-eap-number notranslate">{{ data['CTA Button 1 Phone'] | phoneDash }}</span>
			</ng-container>
			<div class="topic-cards">
				<div *ngFor="let card of topicCardsToShow"><app-topic-card [cardData]="card"></app-topic-card></div>
			</div>
			<div class="load-more-holder">
				<div class="load more" (click)="loadMore()" *ngIf="topicCardsToShow?.length < topicCards?.length" [translate]="'learnmore-load-more'">Load More</div>
				<div class="load less" (click)="showLess()" *ngIf="topicCardsToShow?.length == topicCards?.length" [translate]="'learnmore-show-less'">Show Less</div>
			</div>
		</section>
	</div>

	<section class="assessment fade-in">
		<div class="copy">
			<div class="headline" [translate]="'learnmore-assessment-headline'">Check in on your mental health.</div>
			<div class="text" [translate]="'learnmore-assessment-text'">Not sure where to start? These national mental health assessments provide a quick snapshot of your well-being, helping you recognize patterns and opening the door to deeper conversations with a trusted individual or health provider.</div>
			<div class="actions">
				<a class="cta" href="https://screening.mhanational.org/screening-tools/" target="_blank" [interact]="{ engagementTypeID: 4, resource: 'Take An Assessment' }" [translate]="'learnmore-assessment-cta'">Take an Assessment</a>
			</div>
		</div>
		<div class="img"></div>
	</section>

	<app-crisis-cards-section *ngIf="content[2]" [data]="content[2]" [employer]="employer"></app-crisis-cards-section>

	<section class="faqs fade-in">
		<div class="headline" [translate]="'learnmore-faq-heading'">FAQ</div>
		<ul class="faq-list">
			<li>
				<app-faq [question]="faq1Question" [index]="1">
					<p [innerHTML]="faq1Answer1"></p>
					<p [innerHTML]="faq1Answer2"></p>
					<p [innerHTML]="faq1Answer3"></p>
				</app-faq>
			</li>
			<li>
				<app-faq [question]="faq2Question" [index]="2">
					<p [innerHTML]="faq2Answer"></p>
				</app-faq>
			</li>
			<li>
				<app-faq [question]="faq3Question" [index]="3">
					<p [innerHTML]="faq3Answer"></p>
				</app-faq>
			</li>
			<li>
				<app-faq [question]="faq4Question" [index]="4">
					<p [innerHTML]="faq4Answer"></p>
					<ul class="disc">
						<li [innerHTML]="faq4SubAnswer1"></li>
						<li [innerHTML]="faq4SubAnswer2"></li>
						<li [innerHTML]="faq4SubAnswer3"></li>
					</ul>
				</app-faq>
			</li>
			<li>
				<app-faq [question]="faq5Question" [index]="5">
					<p [innerHTML]="faq5Answer"></p>
				</app-faq>
			</li>
		</ul>
		<div class="contact-info" *ngIf="content[5] as data">
			<ng-container *ngIf="data['Phone Number'] || data['Email']">
				<h5 [innerHTML]="contactEapHeading"></h5>
				<ul>
					<li class="phone" *ngIf="data['Phone Number']">{{ data["Phone Number"] | phone }}</li>
					<li class="email" *ngIf="data['Email']">{{ data["Email"] }}</li>
				</ul>
			</ng-container>
		</div>
	</section>

	<section class="outro">
		<div class="fade-in">
			<p [innerHTML]="outroText"></p>
			<div class="actions">
				<a class="cta" routerLink="/home" [interact]="{ engagementTypeID: 4, resource: 'Back to Home - Learn More Outro' }" [translate]="'learnmore-outro-cta'">Back to Home</a>
			</div>
		</div>
	</section>
</div>
